import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Flex, H1, H4, P, CCard, CFontIcon } from "@appcues/component-library";

const StyledCard = props => (
  <CCard
    width="100%"
    paddingX={24}
    paddingTop={24}
    paddingBottom={21}
    minHeight={140}
    textDecoration="none"
    {...props}
  />
);

const StyledCardTitle = props => (
  <H4 lineHeight="24px" fontSize={13} letterSpacing="0.08em" {...props} />
);

export default class SpecialCard extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    value: PropTypes.node,
    iconClassName: PropTypes.string,
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    isLoading: true
  };

  render() {
    const {
      name,
      description,
      value,
      iconClassName,
      isLoading,
      ...cardProps
    } = this.props;

    return (
      <StyledCard
        is={cardProps.to ? Link : undefined}
        hoverElevation="$box-shadow-3"
        {...cardProps}
      >
        <StyledCardTitle light type="secondary">
          {name}
        </StyledCardTitle>
        <Flex marginTop={3}>
          <H1 light lineHeight="36px">
            {isLoading ? "…" : value}
          </H1>
          {iconClassName && (
            <CFontIcon
              light
              className={iconClassName}
              fontSize={36}
              marginLeft="auto"
              marginRight={11}
            />
          )}
        </Flex>
        <P
          light
          type="secondary"
          fontWeight={600}
          lineHeight="23px"
          fontSize={14}
          marginTop={9}
          opacity={isLoading ? 0 : 1}
        >
          {description}
        </P>
      </StyledCard>
    );
  }
}
